import React, { Component } from 'react'

export default class PostLink extends Component {

  handleClick = event => {
    event.preventDefault()
    this.form.submit()
  }

  buildParams() {
    const { params } = this.props
    const fields = Object.keys(params).map(key => (
      <input key={key} type="hidden" name={key} value={params[key]} />
    ))
    return (
      <span>
        {fields}
      </span>
    )
  }

  render() {
    const { href, target, children, ...props } = this.props
    return (
      <a href={href} target={target} {...props} onClick={this.handleClick}>
        {children}
        <form ref={el => this.form = el} method="POST" action={href} target={target}>
          {this.buildParams()}
        </form>
      </a>
    )
  }

}


// WEBPACK FOOTER //
// client/components/util/PostLink.js